
import { Component, Vue, Prop } from 'nuxt-property-decorator'
import ClientsFeedbackCard from '~/components/sections/clients-feedback/ClientsFeedbackCard.vue'
import LoadMoreButton from '~/components/snippets/LoadMoreButton.vue'
import type { IFeedbackUser } from '~/components/sections/clients-feedback/types'
import type { Theme } from '~/types/theme'
import { AlButton } from '~/components/ui'

@Component({
  components: {
    ClientsFeedbackCard,
    LoadMoreButton,
    AlButton,
  },
})
export default class ClientsFeedbackList extends Vue {
  @Prop({ type: Array, required: true })
  readonly feedbacks!: IFeedbackUser[]

  @Prop({ type: Number, default: 3 })
  readonly count!: number

  @Prop({ default: 'light', type: String })
  readonly theme!: Theme

  private currentShowingCard = this.count

  get currentCardList () {
    return this.feedbacks.slice(0, this.currentShowingCard)
  }

  get isListFullShowed () {
    return this.currentCardList.length >= this.feedbacks.length
  }

  loadMoreCards () {
    if (!this.isListFullShowed) {
      this.currentShowingCard += this.count
    }
  }
}
